module.exports = {
  QUESTION: 'question',
  APPROVAL_TAB_QUESTION: 'question:approval'
};
